import { Component, OnInit } from '@angular/core';
import { SessionService } from '../../shared/services/session.service';
import * as $ from "jquery";

@Component({
  selector: 'app-yr3-wb-index',
  templateUrl: './yr3-wb-index.component.html',
  styleUrls: ['./yr3-wb-index.component.scss']
})
export class Yr3WbIndexComponent implements OnInit {
  public mydevice: string = "";
  public bloburl: string;
  constructor(private sessionService: SessionService, ) {
    this.bloburl = this.sessionService.bloburl;
  }

  ngOnInit() {
    this.bloburl = this.sessionService.bloburl;
    var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    var userAgent = navigator.userAgent.toLowerCase();
    var android_dev = userAgent.indexOf("android") > -1;
    var chrome_browser = userAgent.indexOf("chrome") > -1;
    var samsung_browser = userAgent.indexOf("samsung") > -1;
    if (isIOS) {
      this.mydevice = "ipad";
    }
    else if (android_dev) {
      this.mydevice = "android";

      if (samsung_browser) {
        this.mydevice = this.mydevice + "_samsung";
      }
      else if (chrome_browser) {
        this.mydevice = this.mydevice + "_chrome";

      }
      var body = document.body;
      body.classList.add(this.mydevice);
    }
    //$(".sidenav").css('margin-left', "0%");
    //$(".main").css({ "margin-left": "12.5%" });
    //var mainleftmenu = document.getElementById("opennavbutton");
    //mainleftmenu.style.display = "block";
    $(".leftmenuicon").removeClass("moveleftmenupdflist");
    $("#menu_WorkBook_active").show();
    $("#menuContainer").removeClass("drawingtool_leftmove");
  }

}
